import React, { useState } from "react";
import { GoArrowDown } from "react-icons/go";
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdOutlineGroup,
  MdOutlineKey,
} from "react-icons/md";
import { IoMdLink } from "react-icons/io";

import { LuAlarmClock } from "react-icons/lu";
import { TiMessages } from "react-icons/ti";
import Links from "../sub-components/Links";
const { PUBLIC_URL } = process.env;

const Feature6 = () => {

  const dashboard_Video = process.env.REACT_APP_DASHBOARD_VIDEO;

  const [activeIndex, setActiveIndex] = useState(0);
  const [imgSrc, setImgSrc] = useState(
    `${PUBLIC_URL}/assets/testPortal/proctoring-tp-sec1-1.webp`
  );

  const handleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    if (index === 0) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/proctoring-tp-sec1-1.webp`);
    }
    if (index === 1) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/proctoring-tp-sec1-2.webp`);
    }
    if (index === 2) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/proctoring-tp-sec1-3.webp`);
    }
    if (index === 3) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/proctoring-tp-sec1-4.webp`);
    }
    if (index === 4) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/proctoring-tp-sec1-5.webp`);
    }
    if (index === 5) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/proctoring-tp-sec1-6.webp`);
    }
  };
  return (
    <div>
      <section className="section main-banner" id="f6top">
        <video autoPlay muted loop id="bg-video">
          <source
            src={dashboard_Video}
            type="video/mp4"
          />
        </video>

        <div className="video-overlay header-text">
          <div className="caption">
            <h4 style={{ color: "#f5a425" }}>
              Secure assessments for reliable results
            </h4>
            <h6>
              Enjoy the highest level of protection and reliability <br />
              of results with our advanced proctoring and security features.
            </h6>

            <div className="main-button">
              <div className="scroll-to-section">
                <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
              </div>
            </div>
            <br />
            <div>
              <p style={{ fontSize: "16px", color: "white" }}>Learn more</p>
              <GoArrowDown style={{ color: "white" }} />
            </div>
          </div>
        </div>
      </section>

      <section className="dark-bg2">
        <div className="container-fluid dark-bg-sec">
          <div className="row f6sec1">
            <div className="col-lg-12 f6sec1head">
              <h4>Many ways to ensure the reliability of test results</h4>
              <p>Only authentic, dependable results matter.</p>
            </div>

            <div className="col-lg-6 f6sec1content">
              <ul>
                {activeIndex === 0 ? (
                  <div className="panel">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(0)}
                      >
                        {" "}
                        Question randomization
                        <MdKeyboardArrowUp />
                      </button>
                    </li>
                    <p>
                      Prepare online tests with a unique set of questions for
                      each respondent. Use various question-drawing algorithms.
                      Block respondents from going back or skipping questions.
                    </p>
                  </div>
                ) : (
                  <li className="accordion">
                    <button
                      className="list_button text-white"
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                      onClick={() => handleAccordion(0)}
                    >
                      Question randomization
                      <MdKeyboardArrowDown />
                    </button>
                  </li>
                )}

                {activeIndex === 1 ? (
                  <div className="panel">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(1)}
                      >
                        Strict time measurement
                        <MdKeyboardArrowUp />
                      </button>
                    </li>
                    <p>
                      Test time is measured on the server-side. This means that
                      there is no possibility of altering it and no chance for
                      respondents to cheat during the assessment.
                    </p>
                  </div>
                ) : (
                  <li className="accordion">
                    <button
                      className="list_button text-white"
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                      onClick={() => handleAccordion(1)}
                    >
                      {" "}
                      Strict time measurement <MdKeyboardArrowDown />
                    </button>
                  </li>
                )}

                {activeIndex === 2 ? (
                  <div className="panel">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(2)}
                      >
                        Set number of test attempts
                        <MdKeyboardArrowUp />
                      </button>
                    </li>
                    <p>
                      Test owners can decide how many times their respondents
                      are allowed to take a test. It can be set to one time only
                      or as many times as it takes to pass.
                    </p>
                  </div>
                ) : (
                  <li className="accordion">
                    <button
                      className="list_button text-white"
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                      onClick={() => handleAccordion(2)}
                    >
                      Set number of test attempts
                      <MdKeyboardArrowDown />
                    </button>
                  </li>
                )}

                {activeIndex === 3 ? (
                  <div className="panel">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(3)}
                      >
                        Test activation settings
                        <MdKeyboardArrowUp />
                      </button>
                    </li>
                    <p>
                      Send test notifications to all respondents at the same
                      time and allow simultaneous test access at a pre-set date
                      and time.
                    </p>
                  </div>
                ) : (
                  <li className="accordion">
                    {" "}
                    <button
                      className="list_button text-white"
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                      onClick={() => handleAccordion(3)}
                    >
                      Test activation settings
                      <MdKeyboardArrowDown />
                    </button>
                  </li>
                )}

                {activeIndex === 4 ? (
                  <div className="panel">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(4)}
                      >
                        {" "}
                        Access real-time data feed <MdKeyboardArrowUp />
                      </button>
                    </li>
                    <p>
                      Oversee your respondents and their progress during the
                      test. Access to live data is a game-changer when it comes
                      to making sure your tests produce reliable and insightful
                      information.
                    </p>
                  </div>
                ) : (
                  <li className="accordion">
                    <button
                      className="list_button text-white"
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                      onClick={() => handleAccordion(4)}
                    >
                      Access real-time data feed <MdKeyboardArrowDown />
                    </button>
                  </li>
                )}

                {activeIndex === 5 ? (
                  <div className="panel">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(5)}
                      >
                        {" "}
                        Honest Respondent Technology
                        <MdKeyboardArrowUp />
                      </button>
                    </li>
                    <p>
                      Use a powerful and affordable proctoring solution to
                      monitor test tab movements. Detect cheating attempts and
                      see which question prompted them. Disable a respondent’s
                      access to the test if they leave the test tab too many
                      times.
                    </p>
                  </div>
                ) : (
                  <li className="accordion">
                    <button
                      className="list_button text-white"
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                      onClick={() => handleAccordion(5)}
                    >
                      {" "}
                      Honest Respondent Technology
                      <MdKeyboardArrowDown />
                    </button>
                  </li>
                )}
              </ul>
            </div>

            <div className="col-md-12 col-lg-6 sec3img">
              <article className="video-item">
                <figure>
                  <img
                    src={imgSrc}
                    alt=""
                    // className="background-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/yellow.svg`}
                    alt=""
                    className="overlay-image1"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                    alt=""
                    className="overlay-image2"
                  />
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                    alt=""
                    className="overlay-image3"
                  />
                </figure>
              </article>
            </div>
            {/* </div> */}
          </div>
        </div>
      </section>

      <section className="img-bg">
        <div className="container-fluid img-bg-sec">
          <div className="row f6sec2">
            <div className="col-md-12 col-lg-6 f6sec2img">
              <article className="video-item">
                <figure>
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/proctoring-tp2.webp`}
                    alt=""
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_curve_top.svg`}
                    alt=""
                    className="green_curve_top"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_curve_bottom.svg`}
                    alt=""
                    className="green_curve_bottom"
                  />
                </figure>
              </article>
            </div>

            <div className="col-lg-6 f6sec2content">
              <h3>
                Better integrity and reliability with artificial intelligence
              </h3>
              <p>
                We have teamed up with Examus, the developer and main
                distributor of AI solutions for educational and business
                high-stakes assessments. Together, we offer unparalleled remote
                test accountability. Artificial intelligence created by Examus
                is capable of recognizing emotions and gaze direction. It also
                detects screen-sharing or the presence of another monitor to
                make cheating during online evaluations virtually impossible.
              </p>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href="#section2">
                    Ask us about advanced proctoring solutions
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="dark-bg">
        <div className="container-fluid dark-bg-sec">
          <div className="row f6sec3">
            <div className="col-lg-6 f6sec3content">
              <h3>Combine NexTestify with video call platforms</h3>
              <p>
                Our online test builder is compatible with top conferencing
                platforms such as Zoom, Webex or Google Meet. This allows you to
                use live video to supervise assessments. In the case of
                Microsoft Teams, NexTestify is available as an app within the
                software.
              </p>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href="#section2">
                    Read more about NexTestify in Microsoft Teams
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6 f6sec3img">
              <article className="video-item">
                <figure>
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/proctoring-tp3.webp`}
                    alt=""
                    // className="background-image"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_l_r.svg`}
                    alt=""
                    className="green_l_r"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_r_l.svg`}
                    alt=""
                    className="green_r_l"
                  />
                </figure>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section className="light-bg">
        <div className="container-fluid light-bg-sec">
          <div className="f6sec4">
            <h3>You'll be in good company</h3>
            <div>
              <p>
                We helped these brands turn online assessments into success
                stories. Join them. Elevate your testing.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="dark-bg2">
        <div className="container-fluid dark-bg2-sec">
          <div className="row f6sec5">
            <div className="col-lg-12 f6sec5head">
              <h2>Make life easy for your respondents</h2>
              <h4>
                No account required to start a test. NexTestify makes your
                <br />
                online assessments simple and effective without compromising on
                security.
              </h4>
            </div>

            <div className="f6sec5contenthead">
              <h4>Web browsers</h4>
              <div className="col-lg-12 f6sec5content">
                <div className="row">
                  <div className="col-lg-6">
                    <h3>
                      <span className="f6sec5icon">
                        <IoMdLink />
                      </span>{" "}
                      Test access link
                    </h3>
                    <p>
                      Convenient and easy, but not the most secure way of
                      sharing test access.
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <h3>
                      <span className="f6sec5icon">
                        <MdOutlineGroup />
                      </span>{" "}
                      Group password
                    </h3>
                    <p>
                      Perfect for evaluations of groups who meet offline as
                      well. Optional, customizable “yourcompany.NexTestify.net”
                      subdomain available as a test gateway.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 f6sec5content">
                <div className="row">
                  <div className="col-lg-6">
                    <h3>
                      <span className="f6sec5icon">
                        <MdOutlineKey />
                      </span>{" "}
                      Individual access code{" "}
                    </h3>
                    <p>
                      Our most recommended, secure way of sharing tests. It
                      allows pausing and restarting a test in case of problems.
                      It also allows you to set a maximum number of test
                      attempts.
                    </p>
                  </div>
                  <div className="col-lg-6">
                    {" "}
                    <h3>
                      <span className="f6sec5icon">
                        <LuAlarmClock />
                      </span>{" "}
                      Training
                    </h3>
                    <p>
                      Instant and easy access that provides a great opportunity
                      to practice before taking a real test.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="f6sec5contenthead">
              <h4>Microsoft Teams</h4>
              <div className="col-lg-12 f6sec5content">
                <div className="row">
                  <div className="col-lg-6">
                    <h3>
                      <span className="f6sec5icon">
                        <MdOutlineGroup />
                      </span>{" "}
                      Easy test sharing
                    </h3>
                    <p>
                      Share the test with a level of security comparable to the
                      individual access codes.
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <h3>
                      <span className="f6sec5icon">
                        <TiMessages />
                      </span>{" "}
                      Restrict to a team or chat{" "}
                    </h3>
                    <p>
                      Respondents can gain test access only after Azure Active
                      Directory authorization.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Links />
    </div>
  );
};

export default Feature6;
